module.exports = __webpack_public_path__ + "img/logoIn.f9b722a1.svg";